import { io, type Socket } from 'socket.io-client';
import type {
  ClientToServerEvents,
  ServerToClientEvents,
} from '@livepuls/types';

export type LivepulsSocket = Socket<ServerToClientEvents, ClientToServerEvents>;

let socket: LivepulsSocket | null = null;

export function getSocket(): LivepulsSocket {
  if (socket) return socket;
  socket = io({
    autoConnect: true,
    transports: ['websocket'],
  });
  socket.on('connect', () => {
    socket?.emit('panel:register', { panelId: 'admin', type: 'admin' });
  });
  return socket;
}
